var map = {
	"./amex.png": 951,
	"./diners.png": 952,
	"./discover.png": 953,
	"./jcb.png": 954,
	"./maestro.png": 1182,
	"./mastercard.png": 955,
	"./stripe.png": 956,
	"./union.png": 957,
	"./unknown.png": 625,
	"./visa.png": 958
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1181;